import { useContext, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { UploadImageContext } from '../../context/UploadImage';
import ImageCrop from './ImageCrop';
import { UploadImageEnum } from './UploadImage.enum';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { Icon, Button } from '../../components/UI';

const ImageDropzone = () => {
  const { t } = useTranslation();

  const [image, setImage] = useState({} as any);
  const { uploadImageStep, setUploadImageStep } =
    useContext(UploadImageContext);

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/jpeg,image/png',
    maxFiles: 1,
    maxSize: 5000000,
    onDropAccepted: (acceptedFiles) => {
      setImage(
        Object.assign(image, {
          preview: URL.createObjectURL(acceptedFiles[0]),
          name: acceptedFiles[0].name,
        })
      );
      setUploadImageStep(UploadImageEnum.CROP);
    },
    onDropRejected: (rejectedFiles) => {
      rejectedFiles.forEach((f) => {
        toast.error(t('uploadImage.dropzone.errors.' + f.errors[0].code));
      });
    },
  });

  const cancel = () => {
    setUploadImageStep(UploadImageEnum.CHOOSE_PROFILE_PICTURE);
  };

  return (
    <>
      {uploadImageStep === UploadImageEnum.CROP && (
        <ImageCrop
          fileName={image.name}
          cropShape="round"
          image={image.preview}
        />
      )}
      {uploadImageStep === UploadImageEnum.DROPZONE && (
        <>
          <input {...getInputProps()} />
          <div
            {...getRootProps({
              className:
                'dropzone flex flex-col text-sm items-center justify-center w-full h-112 bg-grey-90 cursor-pointer',
            })}
          >
            {
              <>
                <Icon
                  className="mx-auto w-max h-24 mb-2 "
                  color="grey-70"
                  svgName={'upload'}
                />
                <span className="text-grey-10">
                  {t('uploadImage.dropzone.dragAndDrop')}
                </span>
                <span className="text-grey-50 mt-1">
                  {t('uploadImage.dropzone.yourImageHere')}
                </span>
                <span className="text-grey-10 mt-1">
                  {t('uploadImage.dropzone.clickToChooseFile')}
                </span>
                <span className="text-grey-70 mt-1">
                  {t('uploadImage.dropzone.requisites')}
                </span>
              </>
            }
          </div>
          <div className="p-5 flex-grow-0 w-full flex justify-between items-center">
            <Button
              type="button"
              variant="transparent"
              onClick={() => cancel()}
            >
              {t('uploadImage.dropzone.cancel')}
            </Button>
          </div>
        </>
      )}
    </>
  );
};

export default ImageDropzone;
